import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

function DeleteModal({ modal, onConfirmAction, onCancelAction }) {
	return (
		<Modal centered isOpen={modal} toggle={onCancelAction}>
			<ModalHeader>Remove from Playlist?</ModalHeader>
			<ModalBody>Are you sure you want to remove this video from this playlist?</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={() => onCancelAction()}>
					No
				</Button>
				<Button color="danger" onClick={() => onConfirmAction()}>
					Yes
				</Button>
			</ModalFooter>
		</Modal>
	);
}

export default DeleteModal;
